import { render, staticRenderFns } from "./cardOption.vue?vue&type=template&id=28cf2360"
import script from "./cardOption.vue?vue&type=script&lang=js"
export * from "./cardOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports